var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 15.8333L13.3333 13.3333M8.33341 16.6666H5.99735C5.06576 16.6666 4.59925 16.6666 4.24308 16.4852C3.92948 16.3254 3.6747 16.0702 3.51491 15.7565C3.33325 15.4 3.33325 14.9336 3.33325 14.0001V6.00014C3.33325 5.06672 3.33325 4.59966 3.51491 4.24314C3.6747 3.92954 3.92948 3.67476 4.24308 3.51497C4.5996 3.33331 5.06666 3.33331 6.00008 3.33331H14.0001C14.9335 3.33331 15.3996 3.33331 15.7561 3.51497C16.0697 3.67476 16.3253 3.92954 16.4851 4.24314C16.6666 4.59931 16.6666 5.06581 16.6666 5.9974V8.33348M11.2499 14.1666C9.63909 14.1666 8.33325 12.8608 8.33325 11.25C8.33325 9.63915 9.63909 8.33331 11.2499 8.33331C12.8607 8.33331 14.1666 9.63915 14.1666 11.25C14.1666 12.8608 12.8607 14.1666 11.2499 14.1666Z",
    stroke: "#A3AED0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelect);
export default __webpack_public_path__ + "static/media/select.09682bfdc07aaa8afa6b5c5649535432.svg";
export { ForwardRef as ReactComponent };